module.exports = __webpack_public_path__ + "img/horizontal_1_1_3016.fb1f0040.png";